import Component from '../lib/component';

class Stats extends Component {
  constructor(props) {
    super(props);
    this.state = { ...props };
  }

  // Define the template elements
  template(props) {
    const { distances, unit } = props;
    // Reset template
    this.temp = '';
    // Add template for each model in a loop
    Object.keys(distances).forEach((key) => {
      this.temp = this.temp.concat(`
          <div class="rpc-section__stat">
            <!-- Logo -->
            <img
              srcset="assets/images/${key}.png 74w, assets/images/${key}@2x.png 147w"
              sizes="(max-width: 768px) 74px, 147px"
              src="assets/images/${key}@2x.png"
            />
            <!-- Label -->
            <div class="rpc-section__stat-label">
              <dt class="rpc-section__stat-label-text">${distances[key]}</dt>
              <dd class="rpc-section__stat-label-unit">${unit}</dd>
            </div>
          </div>
      `);
    });

    return this.temp;
  }
}

export default Stats;
